<template>
  <div class="dailyAmountShippedList">
    <div class="block">
      <span class="searchTitle">开始日期：</span>
      <el-date-picker 
          v-model="startDate"
          type="date"
          style="width:240px"
          value-format="yyyy-MM-dd"
          placeholder="请选择开始日期"
          :picker-options="pickerOptions"/>
      <span class="searchTitle">结束日期：</span>
      <el-date-picker 
          v-model="endDate"
          type="date"
          style="width:240px"
          value-format="yyyy-MM-dd"
          placeholder="请选择结束日期"
          :picker-options="pickerOptions"/>
      <el-button type="primary" style="margin-left: 5px" @click="handleSearch">查询</el-button>
      <el-button @click="searchClear">重置</el-button>
    </div>
    <div class="title">发货日报表(单位：万元)</div>
    <el-table v-loading="tabLoading" border :data="firstTableData" style="width: 100%">
      <el-table-column label="日期" fixed="left" width="130" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span style="display: block;padding: 3px 5px">{{scope.row[0]}}</span>
          </template>
          <template v-else>
            <span v-show="(scope.$index !== scope.row.length + 1) && (scope.$index !== scope.row.length + 2)" style="display: block;padding: 3px 5px">{{scope.row[0]}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column v-for="(item, index) in dateRange" :key="index" :label="item" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span style="display: block;padding: 3px 5px">{{scope.row[index + startTime]}}</span>
          </template>
          <template v-else>
            <span v-show="(scope.$index !== scope.row.length + 1) && (scope.$index !== scope.row.length + 2)" style="display: block;padding: 3px 5px">{{scope.row[index + startTime]}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="小计(未税)" fixed="right" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span v-if="scope.$index === firstTableData.length-1 && scope.row[scope.row.length - 1].$index === secondTableData[secondTableData.length-1][scope.row.length - 1].length" style="background: skyblue;display: block;padding: 3px 5px">{{scope.row[scope.row.length - 1]}}</span>
            <span v-else style="display: block;padding: 3px 5px">{{scope.row[scope.row.length - 1]}}</span>
          </template>
          <template v-else>
            <span v-show="false" v-if="scope.$index === firstTableData.length-1 && scope.row[scope.row.length - 1].$index === secondTableData[secondTableData.length-1][scope.row.length - 1].length" style="background: skyblue;display: block;padding: 3px 5px">{{totalPriceList1[scope.$index - 1]}}</span>
            <span v-else v-show="(scope.$index !== scope.row.length + 1)" style="display: block;padding: 3px 5px">{{totalPriceList1[scope.$index]}}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="title">订单额报表(单位：万元)</div>
    <el-table v-loading="tabLoading" border :data="secondTableData" style="width: 100%">
      <el-table-column label="日期" fixed="left" width="130" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span v-if="scope.row[0].startsWith('Sale')" style="display: block;padding: 3px 5px">{{scope.row[0].substring(4,scope.row[0].length)}}</span>
            <span v-else style="display: block;padding: 3px 5px">{{scope.row[0]}}</span>
          </template>
          <template v-else>
            <span v-if="scope.row[0].startsWith('Sale')" style="display: block;padding: 3px 5px">{{scope.row[0].substring(4,scope.row[0].length)}}</span>
            <span v-else v-show="(scope.$index !== scope.row.length + 1) && (scope.$index !== scope.row.length + 2)" style="display: block;padding: 3px 5px">{{scope.row[0]}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column v-for="( item, index ) in dateRange" :key="index" :label="item" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span style="display: block;padding: 3px 5px">{{scope.row[index + startTime]}}</span>
          </template>
          <template v-else>
            <span v-show="(scope.$index !== scope.row.length + 1) && (scope.$index !== scope.row.length + 2)" style="display: block;padding: 3px 5px">{{scope.row[index + startTime]}}</span>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="小计(未税)" fixed="right" align="center">
        <template slot-scope="scope">
          <template v-if="!flag">
            <span v-if="scope.$index === secondTableData.length-1 && scope.row[scope.row.length - 1].$index === secondTableData[secondTableData.length-1][scope.row.length - 1].length" style="background: skyblue;display: block;padding: 3px 5px">{{scope.row[scope.row.length - 1]}}</span>
            <span v-else style="display: block;padding: 3px 5px">{{scope.row[scope.row.length - 1]}}</span>
          </template>
          <template v-else>
            <span v-show="false" v-if="scope.$index === secondTableData.length-1 && scope.row[scope.row.length - 1].$index === secondTableData[secondTableData.length-1][scope.row.length - 1].length" style="background: skyblue;display: block;padding: 3px 5px">{{totalPriceList2[scope.$index - 1]}}</span>
            <span v-else v-show="(scope.$index !== scope.row.length + 1)">{{totalPriceList2[scope.$index]}}</span>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        tabLoading:false,
        startDate:"",
        endDate:"",
        startTime:1,
        endTime: "",
        flag:false,
        sum1: 0,
        sum2: 0,
        totalPriceList1:[],
        totalPriceList2:[],
        dateRange: [],
        firstTableData: [],
        secondTableData:[],
        pickerOptions:{
          disabledDate(time) {
            let now = new Date();
            let currentMonth = now.getMonth();
            let firstDay = new Date(now.getFullYear(),currentMonth+1, 0);
            firstDay.setDate(1);
            return (time.getTime() > now.getTime()) || (time.getTime() < firstDay.getTime());
          },
        },
      };
    },

    mounted() {
      this.dateRange = this.enumerateDaysBetweenDates(this.getFormatMonth(new Date()), this.getFormatDate(new Date()));
      this.getDataByDateRange();
    },

    methods: {
      // 获取日期
      enumerateDaysBetweenDates(startDate, endDate) {
        let daysList = [];
        const start = this.$moment(startDate);
        const end = this.$moment(endDate);
        daysList.push(start.format("MM/DD"));
        while (start.add(1, "days").isBefore(end)) {
          daysList.push(start.format("MM/DD"));
        }
        if(startDate !== endDate) {
          daysList.push(end.format("MM/DD"));
        }
        console.log(daysList);
        return daysList;
      },
      //获取当前月
      getFormatMonth(date) {
        var month = date.getMonth() + 1;
        var strDate = "01";
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },
      // 获取当前时间
      getFormatDate(date) {
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        this.endTime = strDate;
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate;
      },

      getDataByDateRange() {
        this.tabLoading = true;
        this.$http.get("basic", "sAPShipmentInvoices/getDailyAmountShipped").then((resp) => {
          console.log(resp);
          this.firstTableData = resp[0];
          this.secondTableData = resp[1];
          this.tabLoading = false;
        });
      },

      handleSearch() {
        if(!this.startDate || !this.endDate) {
          this.dateRange = this.enumerateDaysBetweenDates(this.getFormatMonth(new Date()), this.getFormatDate(new Date()));
          this.getDataByDateRange();
        }else{
          this.startTime = parseInt(this.startDate.slice(8,10));
          this.endTime = parseInt(this.endDate.slice(8,10));
          if(this.startTime > this.endTime) {
            this.$message.error("请选择正确的查询日期！");
            this.startTime = 1;
            return;
          }else {
            console.log("1233123123123123");
            this.flag = true;
            this.dateRange = this.enumerateDaysBetweenDates(this.startDate,this.endDate);
            this.totalPriceList1 = [];
            this.totalPriceList2 = [];
            for(var i = 0; i < this.firstTableData.length-2; i++) {
              this.sum1 = 0 ;
              this.sum2 = 0;
              for(var j = this.startTime; j <= this.endTime; j++) {
                this.sum1 += this.firstTableData[i][j];
                this.sum2 += this.secondTableData[i][j];
              }
              this.sum1 = parseFloat(this.sum1).toFixed(2);
              this.sum2 = parseFloat(this.sum2).toFixed(2);
              this.totalPriceList1.push(this.sum1);
              this.totalPriceList2.push(this.sum2);
            }
          }
        }
      },

      searchClear() {
        this.startDate = "";
        this.endDate = "";
        this.flag = false;
        this.totalPriceList1 = [],
        this.totalPriceList2 = [],
        this.dateRange = this.enumerateDaysBetweenDates(this.getFormatMonth(new Date()), this.getFormatDate(new Date()));
        this.getDataByDateRange();
        this.startTime = 1 ;
      },
    },
  };
</script>
<style lang="scss">
  .dailyAmountShippedList{
    .title {
      text-align: center;
      margin: 10px 0;
      font-size: 18px;
      font-weight: 700;
    }
    .el-table td, .el-table th{
      padding: 0px !important;
    }
    .cell{
      padding: 0px!important;
    }
  }
  .searchTitle {
    font-size: 13px;
    margin-left: 5px;
  }

</style>